import React, { useEffect, useState } from "react";
import Navbar from "./component/Navbar";
import TestimoniSection from "./section/Testimoni";
import KontakSection from "./section/Kontak";
import PriceSection from "./section/PriceSection";
import UnitSection from "./section/UnitSection";
import { Button } from "./component/Button";
import HeroSection from "./section/HeroSection";
import axios from "axios";
import ChatPopup from "./component/ChatPopup";
import Footer from "./section/Footer";
import ServiceSection from "./section/ServiceSection";
import "./i18n"; // Pastikan ini dipanggil di root atau index.js
import VisionMissionSection from "./section/VisionMissionSection";
import TourManagementSection from "./section/TourManagementSection";
export default function RentalMobil() {
  const [menuOpen, setMenuOpen] = useState(false);

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [PROJECT_NAME, SET_PROJECT_NAME] = useState("Paksong");
  const [PROJECT_LOGO, SET_PROJECT_LOGO] = useState(null);
  const [PROJECT_COMPANY, SET_PROJECT_COMPANY] = useState("CV. Paksong Medan");
  const [PROJECT_ADDRESS, SET_PROJECT_ADDRESS] = useState("Jl. Bambu");
  const [PROJECT_WHATSAPP, SET_PROJECT_WHATSAPP] = useState("");
  const [PROJECT_INSTAGRAM, SET_PROJECT_INSTAGRAM] = useState("");
  const [PROJECT_FACEBOOK, SET_PROJECT_FACEBOOK] = useState("");
  const [PROJECT_TIKTOK, SET_PROJECT_TIKTOK] = useState("");

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await axios.get(`${BASE_URL}api/rentcar/company`, {});
        const { company, address, name, logo } = response.data;

        SET_PROJECT_COMPANY(company);
        SET_PROJECT_ADDRESS(address);
        SET_PROJECT_NAME(name);
        SET_PROJECT_LOGO(`${BASE_URL}upload/logo/${logo}`)
      } catch (error) {
        console.error('Gagal mengambil data perusahaan:', error);
      }
    };

    const fetchInfo = async () => {
      try {
        const response = await axios.get(`${BASE_URL}api/rentcar/company/info`, {});

        const { facebook, instagram, whatsapp } = response.data;

        SET_PROJECT_WHATSAPP(whatsapp);
        SET_PROJECT_INSTAGRAM(instagram)
        SET_PROJECT_FACEBOOK(facebook)
        // SET_PROJECT_TIKTOK()

      } catch (error) {
        console.error('Gagal mengambil data perusahaan:', error);
      }
    };

    fetchCompany();
    fetchInfo();
  }, [BASE_URL]);

  return (
    <div className="font-sans text-gray-800 scroll-smooth">
      {/* Navbar */}
      <Navbar ProjectLogo={PROJECT_LOGO} ProjectName={PROJECT_NAME} />

      {/* Hero */}
      <HeroSection />

      <ServiceSection/>

      <TourManagementSection/>

      {/* Unit Section */}
      <UnitSection />

      {/* Harga Section */}
      {/* <PriceSection /> */}

      <VisionMissionSection/>

      <TestimoniSection />

      {/* Kontak */}
      {/* <KontakSection
        projectName={PROJECT_NAME}
        projectAddress={PROJECT_ADDRESS}
        projectWhatsapp={PROJECT_WHATSAPP}
      /> */}

      {/* Footer */}
      <Footer
        // logo={PROJECT_LOGO}
        project={PROJECT_NAME}
        company={PROJECT_COMPANY}
        address={PROJECT_ADDRESS}
        phone={PROJECT_WHATSAPP}
        instagram={PROJECT_INSTAGRAM}
        facebook={PROJECT_FACEBOOK}
      />
      {/* <footer className="bg-white text-center p-4 shadow-inner">
        <p>&copy; 2025 {PROJECT_NAME} - All rights reserved</p>
      </footer> */}

      <ChatPopup phoneNumber={PROJECT_WHATSAPP} />
    </div>
  );
}
